import { ClipboardModule } from '@angular/cdk/clipboard';
import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import '@angular/localize/init';
import { BadgeComponent } from '@epicuro-next/ataraxia/badge';
import { ButtonsModule } from '@epicuro-next/ataraxia/buttons';
import { CardModule } from '@epicuro-next/ataraxia/card';
import { CarouselModule } from '@epicuro-next/ataraxia/carousel';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { DiscountLabelModule } from '@epicuro-next/ataraxia/discount-label';
import { DomSanitizerModule } from '@epicuro-next/ataraxia/dom-sanitizer';
import { EllipsisModule } from '@epicuro-next/ataraxia/ellipsis';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { MarketingBadgeModule } from '@epicuro-next/ataraxia/marketing-badge';
import { MediaLightboxModule } from '@epicuro-next/ataraxia/media-lightbox';
import { PanelsModule } from '@epicuro-next/ataraxia/panels';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { ProductCardModule as AtaraxiaProductCardModule } from '@epicuro-next/ataraxia/product-card';
import { ProductDabModule } from '@epicuro-next/ataraxia/product-dab';
import { ProductImageModule } from '@epicuro-next/ataraxia/product-image';
import { ProductPriceModule } from '@epicuro-next/ataraxia/product-price';
import {
  ProductIdPipe,
  ProductTitleModule,
} from '@epicuro-next/ataraxia/product-title';
import { SkeletonBasicModule } from '@epicuro-next/ataraxia/skeleton-basic';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { ConfigStripComponentModule } from '@epicuro-next/features/config-strip/component';
import { EngagementCommonModule } from '@epicuro-next/features/engagement/engagement-common';
import { DynamicComponentsModule } from '@epicuro-next/platform/dynamic-components';
import { ListProductReferenceEntitiesModule } from '@epicuro-next/state/list-product-reference-entities';
import { UserStateModule } from '@epicuro-next/state/user-state';
import { LetDirective } from '@ngrx/component';
import { ProductLabelsComponent } from 'ataraxia-product-labels';
import { SimilarProductsContainerComponent } from 'features-similar-products';

import { ProductCardActionsComponent } from './product-card-actions/product-card-actions.component';
import { ProductCardBaseComponent } from './product-card-base/product-card-base.component';
import { ProductCardCommercialComponent } from './product-card-commercial/product-card-commercial.component';
import { ProductCardExpandContainerComponent } from './product-card-expand/product-card-expand-container/product-card-expand-container.component';
import { ProductCardHeaderComponent } from './product-card-header/product-card-header.component';
import { ProductCardIconsComponent } from './product-card-icons/product-card-icons.component';
import { ProductCardSkeletonComponent } from './product-card-skeleton/product-card-skeleton.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { ProductOverlayComponent } from './product-overlay/product-overlay.component';

@NgModule({
  imports: [
    CommonModule,
    CarouselModule,
    CardModule,
    IconsModule,
    TooltipDirective,
    LayoutModule,
    EllipsisModule,
    UserStateModule,
    DiscountLabelModule,
    ProductTitleModule,
    MediaLightboxModule,
    ClipboardModule,
    SnackBarModule,
    LetDirective,
    SkeletonBasicModule,
    ImageModule,
    ListProductReferenceEntitiesModule,
    ConfigStripComponentModule,
    PopoverModule,
    EngagementCommonModule,
    DateModule,
    PanelsModule,
    MarketingBadgeModule,
    ProductPriceModule,
    ButtonsModule,
    BadgeComponent,
    ProductImageModule,
    ProductDabModule,
    ProductDabModule,
    FormatPricePipe,
    FormatPricePipe,
    AtaraxiaProductCardModule,
    DynamicComponentsModule,
    ProductLabelsComponent,
    DomSanitizerModule,
    ProductIdPipe,
    SimilarProductsContainerComponent,
  ],
  declarations: [
    ProductCardBaseComponent,
    ProductCardComponent,
    ProductCardCommercialComponent,
    ProductCardHeaderComponent,
    ProductOverlayComponent,
    ProductCardSkeletonComponent,
    ProductCardActionsComponent,
    ProductCardIconsComponent,
    ProductCardExpandContainerComponent,
  ],
  exports: [
    ProductCardBaseComponent,
    ProductCardComponent,
    ProductCardCommercialComponent,
    ProductCardSkeletonComponent,
    ProductCardExpandContainerComponent,
  ],
})
export class ProductCardModule {}
